import { LOGIN_URL, ERROR_MESSAGE, TOKEN, CID, LOCALHOST } from "src/common/constants";
import MsModal from "src/components/ms-common/ms-modal/MsModal";
import Tools from "./tools";

export function fetchApi(method: string, url: string, data?: any) {
  let hideError = false;
  const token = TOKEN;
  const cId = CID;
  const path = LOCALHOST;

  // 是否不处理error
  if (data && data.hideError === true) {
    hideError = true;
    delete data.hideError;
  }

  // header设置
  const headers = {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    "Pragma": "no-cache",
    "Authorization": "Bearer " + token,
    "Mscid": cId
  };

  // CID和token check
  if (!token) {
    delete headers.Authorization;
  }
  if (!cId) {
    delete headers.Mscid;
  }

  // 发出请求
  return fetch(path + "/" + url, {
    method,
    headers: {...headers},
    body: method === "post" ? JSON.stringify(data) : undefined
  })
  .then(res => res.json())
  .then(value => {
    if (value.result === 401) {
      MsModal.error({content: "登陆已过期，请重新登陆！", onOk: () => {
        Tools.delCookie("ms_member_token");
        Tools.delCookie("ms_cid");
        location.href = LOGIN_URL;
      }})
    }
    else if (value.result !== 0 && !hideError) {
      MsModal.error({content: value.detail || ERROR_MESSAGE});
    }
    else {
      return value;
    }
  })
  .catch(() => {
    MsModal.error({content: ERROR_MESSAGE});
  })
}

// 返回文件流类型
export function fetchFileApi(method: string, url: string, data?: any) {
  const token = TOKEN;
  const cId = CID;
  const path = LOCALHOST;

  // header设置
  const headers = {
    "Cache-Control": "no-cache",
    "Pragma": "no-cache",
    "Authorization": "Bearer " + token,
    "Mscid": cId
  };

  // CID和token check
  if (!token) {
    delete headers.Authorization;
  }
  if (!cId) {
    delete headers.Mscid;
  }

  // 发出请求
  return fetch(path + "/" + url, {
    method,
    headers: {...headers},
  })
  .then(res => res.blob())
}



// WEBPACK FOOTER //
// ./src/utils/fetchApi.ts